import Community from "../../../../src/pages/community/index.md";
import * as React from 'react';
export default {
  Community,
  React
};